import type { AdminMediaPost } from "@/components/admin/adminMedia";

import {

  resolveAdminImageUrl,

  resolveAdminPosterUrl,

  resolveAdminVideoUrl,

} from "@/components/admin/adminMedia";



type Props = {

  post: AdminMediaPost;

  tall?: boolean;

  variant?: "auto" | "image" | "video";

  className?: string;

  /** Show native video controls (drifts tab). */

  controls?: boolean;

};



export function AdminMediaPreview({

  post,

  tall,

  variant = "auto",

  className = "",

  controls = false,

}: Props) {

  const videoUrl = resolveAdminVideoUrl(post);

  const imageUrl = resolveAdminImageUrl(post);

  const poster = resolveAdminPosterUrl(post);

  const size = tall ? "h-48 w-[108px]" : "h-20 w-20";

  const showVideo =

    variant === "video" || (variant === "auto" && Boolean(post.is_drift));



  if (showVideo) {

    if (videoUrl) {

      return (

        <div

          className={[

            "relative shrink-0 overflow-hidden rounded-xl border border-black/[0.06] bg-black",

            size,

            className,

          ].join(" ")}

        >

          <video

            src={videoUrl}

            poster={poster ?? undefined}

            className="h-full w-full object-cover"

            muted={!controls}

            playsInline

            preload="metadata"

            controls={controls}

            onMouseEnter={

              controls

                ? undefined

                : (e) => {

                    void e.currentTarget.play().catch(() => undefined);

                  }

            }

            onMouseLeave={

              controls

                ? undefined

                : (e) => {

                    e.currentTarget.pause();

                    e.currentTarget.currentTime = 0;

                  }

            }

          />

          {!controls ? (

            <span className="pointer-events-none absolute bottom-1 right-1 rounded bg-black/65 px-1 py-0.5 text-[10px] font-medium text-white">

              ▶

            </span>

          ) : null}

        </div>

      );

    }



    return (

      <div

        className={[

          "flex shrink-0 flex-col items-center justify-center rounded-xl border border-dashed border-amber-300 bg-amber-50 px-2 text-center text-[10px] text-amber-900",

          size,

          className,

        ].join(" ")}

      >

        No video URL

        {poster ? (

          <img src={poster} alt="" className="mt-1 max-h-16 rounded object-cover opacity-70" />

        ) : null}

      </div>

    );

  }



  if (!imageUrl && !poster) {

    return (

      <div

        className={[

          "flex shrink-0 items-center justify-center rounded-xl border border-dashed border-black/15 bg-[#f0f0f0] text-[10px] text-ink-muted",

          size,

          className,

        ].join(" ")}

      >

        No media

      </div>

    );

  }



  return (

    <img

      src={imageUrl ?? poster ?? ""}

      alt=""

      className={[

        "shrink-0 rounded-xl border border-black/[0.06] object-cover bg-[#f0f0f0]",

        size,

        className,

      ].join(" ")}

      loading="lazy"

    />

  );

}



export type { AdminMediaPost };

